export default "/kiban/_next/static/images/top_green-f37532aa90cd34b040cf35f3bcf4400c.png";